/** Same runtime-config-over-build-time-env pattern as web/src/services/runtimeConfig.js. */
const runtime = typeof window !== "undefined" ? window.__RUNTIME_CONFIG__ : undefined;

function pick(runtimeKey, viteKey, fallback = "") {
  return runtime?.[runtimeKey] || import.meta.env[viteKey] || fallback;
}

export const config = {
  apiBaseUrl: pick("API_BASE_URL", "VITE_API_BASE_URL", "http://localhost:7071/api"),
  b2cClientId: pick("B2C_CLIENT_ID", "VITE_B2C_CLIENT_ID"),
  b2cAuthority: pick("B2C_AUTHORITY", "VITE_B2C_AUTHORITY"),
  b2cKnownAuthority: pick("B2C_KNOWN_AUTHORITY", "VITE_B2C_KNOWN_AUTHORITY"),
  b2cMfaAuthority: pick("B2C_MFA_AUTHORITY", "VITE_B2C_MFA_AUTHORITY"),
  b2cRedirectUri: pick("B2C_REDIRECT_URI", "VITE_B2C_REDIRECT_URI", window?.location?.origin),
  sessionTimeoutMinutes: Number(pick("SESSION_TIMEOUT_MINUTES", "VITE_SESSION_TIMEOUT_MINUTES", "15")),
  statusPageUrl: pick("STATUS_PAGE_URL", "VITE_STATUS_PAGE_URL"),
};
